import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import SeeMore from './SeeMore';

import images from '../../style/img/flag/images';

const CountryProfileTextTab = props => {

	const [maxCharacters, setMaxCharacters] = useState(props.maxCharacters ? props.maxCharacters : 200);
	const [toggleSeeMore, setToggleSeeMore] = useState(false);
	const [toggleSeeMore2, setToggleSeeMore2] = useState(false);
	const [toggleSeeMore3, setToggleSeeMore3] = useState(false);

	useEffect(() => {
		setToggleSeeMore(false);
		setToggleSeeMore2(false);
		setToggleSeeMore3(false);
	}, [props.tabName])

    const isOneCountrySelected = () => {
		if(props.country2 !== undefined && props.country2 !== null && props.country2 !== "")
		{
			if (props.country2.code != '') {
				if(props.country3 !== undefined && props.country3 !== null && props.country3 !== "")
				{
					if (props.country3.code != '') {
						return "no-full3";
					}else{
						return "no-full";
					}
				}
				else
				{
					return "no-full";
				}
			} 
			else 
			{
				return "full"
			}
		}
		else
		{
			return "full";
		}
	}

    const trimText = (pVal) => {
		let shortText = pVal;
		let newMaxCharacter = maxCharacters;
		let numCharacters = maxCharacters;
  
		if(shortText != null){
			let firstSplit =  shortText.substring(0, newMaxCharacter);

			if(firstSplit.match('<a')){
				numCharacters += 150;
			}

			let indexStart = shortText.indexOf('<a');
			let indexEnd = shortText.indexOf('>', indexStart);

			if(indexStart != -1){
				while (indexStart != -1){
					let link = shortText.substring(indexStart, indexEnd);
					newMaxCharacter = newMaxCharacter + link.length;
					indexStart = shortText.indexOf('<a', indexEnd);
					indexEnd = shortText.indexOf('>', indexStart);
				}
			}

			if (shortText.length > newMaxCharacter ) {
				shortText = shortText.trim().substring(0, numCharacters).split(" ").slice(0, -1).join(" ") + "<span class='dots'>...</span>";
			}
			return ReactHtmlParser(shortText);
		}
	}

	const toggleText = (callback) => {
		setToggleSeeMore(callback);
	}

	const toggleText2 = (callback) => {
		setToggleSeeMore2(callback);
	}

	const toggleText3 = (callback) => {
		setToggleSeeMore3(callback);
	}

	const notFirstCountryContent = (pClass, pCountry, pNoInfoMsg, pToggleSeeMore, pCountryText, pToggleFunction) => {
		return (
			<div className={ `column--item ${ pClass } ` }>
				<div className="">
					{ props.page == 'enforcement' && ( <img className="flags--wrapper" src = { `${ pCountry.code && images[ pCountry.code.toLowerCase() ] }` } alt = { pCountry.name } />) }
					{ !props.page && ( <img className="flags--wrapper" src = { `${ pCountry && images[ pCountry.code.toLowerCase() ] }` } alt = { pCountry && pCountry.name } />) }
				</div>
				<h2>{ props.literals[`L${tabName}`] }</h2>
				<div className="columm--item--content">
					<p className="download-report">
						{ !props.page && (
							<a href={`/osh-barometer/osh-steering/country-profile/National-Strategies-Mapping_${pCountry.name}.pdf`}
							className="download-pdf" target="_blank">{ props.literals.L20640 }</a> 
						)}
					</p>
					{ props.page == 'enforcement' && pNoInfoMsg && ( pNoInfoMsg.map( (element, index) => <div key={ `${index}-${element}` } className="partial-text-profile"> {ReactHtmlParser(props.literals[`L${element}`])} </div>))}
					<div className="complete-text" style={ { display: pToggleSeeMore ? 'block' : 'none' } } >
						{ ReactHtmlParser( props.literals['L'+pCountryText] ) }
					</div>
					<div className="partial-text" style={ { display: pToggleSeeMore ? 'none' : 'block' } } >{ trimText( props.literals['L'+pCountryText] ) }</div>	
					<SeeMore 
						text = { props.literals['L'+pCountryText] } 
						maxCharacters = { maxCharacters }
						toggleSeeMore = { pToggleSeeMore }
						onCallbackToggle = { pToggleFunction }
						tabName = { props.tabName }
						literals = { props.literals }
					/>
				</div>
			</div>
		)
	}

    const tabName = props.tabName;
       
	var secondCountryContainer =  "";

	if( props.country2 != undefined && props.country2 != {} && props.country2.code ){
		secondCountryContainer = notFirstCountryContent("second", props.country2, props.noInfoMsg2, toggleSeeMore2, props.country2Text, toggleText2)
	}

	let thirdCountryContainer =  "";

	if( props.country3 != undefined && props.country3 != {} && props.country3.code )
	{
		thirdCountryContainer = notFirstCountryContent("third", props.country3, props.noInfoMsg3, toggleSeeMore3, props.country3Text, toggleText3)
	}

	return (
		<div className={"column--grid--block "+isOneCountrySelected()}>
			<div className={"column--item first "+isOneCountrySelected()}>
				<div>
					{ props.page == 'enforcement' && ( <img className="flags--wrapper" src = { `${props.country1.code && images[ props.country1.code.toLowerCase() ] }` } alt = { props.country1.name } /> ) }
					{ props.page == 'regulation' && ( <img className="flags--wrapper" src = { `${props.country1 && images[ props.country1.code.toLowerCase() ] }` } alt={ props.country1 && props.country1.name } /> ) }
					{ !props.page && ( <img className="flags--wrapper" src = { `${props.country1 && images[ props.country1.code.toLowerCase() ] }` } alt = { props.country1 && props.country1.name } /> ) }
				</div>
				<h2>{ props.literals[`L${tabName}`] }</h2>
				<div className="columm--item--content">
					{ !props.page && (
						<p className="download-report">
							<a href={`/osh-barometer/osh-steering/country-profile/National-Strategies-Mapping_${ props.country1.name}.pdf`} 
								className="download-pdf" target="_blank">{ props.literals.L20640 }</a>
						</p>
					)}
					{ props.page == 'enforcement' && props.noInfoMsg1 && ( props.noInfoMsg1.map( (element, index) => <div key={ `${index}-${element}` } className="partial-text-profile"> {ReactHtmlParser(props.literals[`L${element}`])} </div>) ) }
					<div className="partial-text" style={ { display: !toggleSeeMore ? 'block' : 'none' } } >{ trimText( props.literals['L'+props.country1Text] ) }</div>
					<div className="complete-text" style={ { display: toggleSeeMore ? 'block' : 'none' } } >{ ReactHtmlParser( props.literals['L'+props.country1Text] ) }</div>
					<SeeMore 
						text = { props.literals['L'+props.country1Text] } 
						maxCharacters = { maxCharacters }
						toggleSeeMore = { toggleSeeMore }
						onCallbackToggle = { toggleText }
						tabName = { props.tabName }
						literals = { props.literals }
					/>
				</div>
			</div>
			{secondCountryContainer}
			{thirdCountryContainer}
		</div>
	)
}

export default CountryProfileTextTab;